import { AxiosResponse } from "axios";
import { Module } from "vuex";
import { SET_ERRORMSG, SET_USER, SET_USERS } from "../mutation_types";
import {
    CLEAR_USERS_ISLOADING,
    DELETE_USER,
    GET_USERS,
    REGISTER_USER,
} from "../action_types";
import { StateObject } from "@/dtos/state.dto";
import User from "@/services/user";
import { GetUser, RegisterUser } from "@/dtos/user.dto";

const user: Module<any, {}> = {
    state: {
        user: { data: null, isLoading: false },
        users: { data: null, metaData: null, isLoading: false },
    },
    getters: {
        user: (state) => state.user,
        users: (state) => state.users,
    },
    mutations: {
        [SET_USER]: (state: { user: StateObject }, payload: any) => {
            if (payload.data !== undefined) state.user.data = payload.data;
            state.user.isLoading = payload.isLoading;
        },
        [SET_USERS]: (state: { users: StateObject }, payload: any) => {
            if (payload.data !== undefined) state.users.data = payload.data;
            if (payload.metaData !== undefined) state.users.metaData = payload.metaData;
            state.users.isLoading = payload.isLoading;
        },
    },
    actions: {
        [REGISTER_USER]: async ({ commit }, payload: RegisterUser) => {
            commit(SET_USER, { data: null, isLoading: true });
            const result: AxiosResponse = await User.registerUser(payload);
            if (result?.data?.status) {
                commit(SET_USER, { data: result.data.data, isLoading: false });
                return true;
            }
            commit(SET_USER, { isLoading: false });
            if (result) commit(SET_ERRORMSG, result.data.msg);
            return false;
        },
        [GET_USERS]: async ({ commit }, payload: GetUser) => {
            commit(SET_USERS, { data: null, isLoading: true });
            const result: AxiosResponse = await User.getUsers(payload ?? {});
            if (result?.data?.status) {
                commit(SET_USERS, {
                    data: result.data.data,
                    metaData: result.data.metaData,
                    isLoading: false,
                });
                return true;
            }
            commit(SET_USERS, { isLoading: false });
            if (result) commit(SET_ERRORMSG, result.data.msg);
            return false;
        },
        [DELETE_USER]: async ({ commit }, payload: string) => {
            commit(SET_USER, { isLoading: true });
            const result: AxiosResponse = await User.deleteUser(payload);
            if (result?.data?.status) {
                commit(SET_USER, { data: result.data.data, isLoading: false });
                return true;
            }
            commit(SET_USER, { isLoading: false });
            if (result) commit(SET_ERRORMSG, result.data.msg);
            return false;
        },
        [CLEAR_USERS_ISLOADING]: ({ commit }) => {
            commit(SET_USER, { isLoading: false });
            commit(SET_USERS, { isLoading: false });
        },
    },
};

export default user;
